import { colors } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, Text } from "../../../../../../mads";
import { useEmployerOutreachInfo } from "../../../../hooks/useEmployerOutreachInfo";
import { useEmployerOutreachUIConfig } from "../../../../hooks/useEmployerOutreachUIConfig";

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 32,
    paddingTop: 16,
    paddingBottom: 8,
    borderTopColor: colors.borderWeak,
    borderTopWidth: 1,
  },
  headerRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    alignSelf: "center",
  },
  headerIcon: {
    marginRight: 8,
    paddingTop: 0,
  },
  textContainer: {
    alignItems: "center",
  },
  headerTextWrapper: {
    flexShrink: 1,
  },
});

export interface EmployerOutreachEnticerContentProps {
  jobKey: string;
}

export const EmployerOutreachEnticerContent: React.FC<EmployerOutreachEnticerContentProps> = ({
  jobKey,
}) => {
  const result = useEmployerOutreachInfo(jobKey);
  const outreachInfo = result?.outreachInfo ?? null;
  const uiConfig = useEmployerOutreachUIConfig(outreachInfo);

  const enticerText = uiConfig.textContent?.header;

  if (!enticerText) {
    return null;
  }

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.textContainer}>
        <Box sx={styles.headerRow}>
          {uiConfig.textContent?.icon && (
            <Box sx={styles.headerIcon}>{uiConfig.textContent.icon}</Box>
          )}
          <Box sx={styles.headerTextWrapper}>
            <Text sx={{ color: "foreground", textAlign: "center" }}>{enticerText}</Text>
          </Box>
        </Box>
        {uiConfig.textContent?.subheader && (
          <Text level={2} sx={{ color: "foreground", textAlign: "center" }}>
            {uiConfig.textContent.subheader}
          </Text>
        )}
      </Box>
    </Box>
  );
};
